import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vdmar_panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", null, "НАСТРОЙКИ MP3 Плеера", -1)
const _hoisted_3 = { class: "mp3settings" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Выбранные жанры", -1)
const _hoisted_5 = ["onClick", "value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "mp3settings" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Выбранные форматы", -1)
const _hoisted_9 = { class: "mp3setting_block" }
const _hoisted_10 = ["onClick", "value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "mp3setting_block" }
const _hoisted_13 = ["onClick", "value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: "vdmar_fieldset",
      style: _normalizeStyle(_ctx.styleObject)
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countBlock, (value, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mp3setting_block",
            key: key
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseGenres.slice((value-1) * Math.trunc(_ctx.baseGenres.length/_ctx.countBlock), Math.trunc(value*(_ctx.baseGenres.length/_ctx.countBlock))), (baseGenre) => {
              return (_openBlock(), _createElementBlock("div", {
                key: baseGenre.id
              }, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.genres) = $event)),
                    onClick: ($event: any) => (_ctx.save(baseGenre.id, $event)),
                    value: baseGenre.id
                  }, null, 8, _hoisted_5), [
                    [_vModelCheckbox, _ctx.genres]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(baseGenre.name), 1)
                ]),
                _createTextVNode(),
                _hoisted_6
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseAlbumTypes.slice(0, 4), (baseFormat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: baseFormat.id
            }, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.album_types) = $event)),
                  onClick: ($event: any) => (_ctx.saveFormat(baseFormat.id, $event)),
                  value: baseFormat.id
                }, null, 8, _hoisted_10), [
                  [_vModelCheckbox, _ctx.album_types]
                ]),
                _createElementVNode("span", null, _toDisplayString(baseFormat.name), 1)
              ]),
              _createTextVNode(),
              _hoisted_11
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseAlbumTypes.slice(4, 9), (baseFormat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: baseFormat.id
            }, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.album_types) = $event)),
                  onClick: ($event: any) => (_ctx.saveFormat(baseFormat.id, $event)),
                  value: baseFormat.id
                }, null, 8, _hoisted_13), [
                  [_vModelCheckbox, _ctx.album_types]
                ]),
                _createElementVNode("span", null, _toDisplayString(baseFormat.name), 1)
              ]),
              _createTextVNode(),
              _hoisted_14
            ]))
          }), 128))
        ])
      ])
    ], 4)
  ]))
}